import { render, staticRenderFns } from "./DdsPrioritizeSuits.vue?vue&type=template&id=fb7ec7ce&scoped=true&"
import script from "./DdsPrioritizeSuits.vue?vue&type=script&lang=js&"
export * from "./DdsPrioritizeSuits.vue?vue&type=script&lang=js&"
import style0 from "./DdsPrioritizeSuits.vue?vue&type=style&index=0&id=fb7ec7ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb7ec7ce",
  null
  
)

export default component.exports